<!--
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-12-10 10:27:15
-->
<template>
  <div class="agreement">
    <span class="titleName" @click="visiblefn">{{ $t("login.termsService") }}</span>
  </div>
</template>

<script>
import {
  onMounted,
  reactive,
  toRefs
} from "vue";
export default {
  components: {},
  setup() {
    const state = reactive({
      visible: false
    });
    const method = reactive({
      visiblefn() {
        window.open("https://tgr.co/terms-of-use");
        // if (process.env.VUE_APP_IS_NA && process.env.VUE_APP_IS_NA == "yes") {
        //   window.open('https://adibot.com/adibot-privacy-policy/');
        // } else {
        //   getprivacy().then(res => {
        //     console.log(res.data[0].slice(-6, -4));
        //     // const pafurl = (res.data[0].slice(-6,-4) = 'EN'?res.data[0]:res.data[0])
        //     let ENpafurl = "";
        //     let CNpafurl = "";
        //     if (res.data[0].slice(-6, -4) == "EN") {
        //       ENpafurl = res.data[0];
        //       CNpafurl = res.data[1];
        //       //  console.log(ENpafurl)
        //     } else {
        //       ENpafurl = res.data[1];
        //       CNpafurl = res.data[0];
        //     }
        //     if (getLanguage() == "zh-cn") {
        //       window.open(CNpafurl);
        //     } else {
        //       window.open(ENpafurl);
        //     }
        //   });
        // }
      }
    });
    onMounted(() => { });
    return {
      ...toRefs(state),
      ...toRefs(method)
    };
  }
};
</script>

<style lang="scss" scoped>
.agreement {
  display: inline-block;

  .fontbold {
    font-weight: 600;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .titleName {
    color: #40a9ff;
    cursor: pointer;
  }

  .agreementInfo {
    height: 800px;
    overflow-y: auto;
  }

  .contentBox {
    padding: 50px 34px;
    text-align: left;

    .center {
      text-align: center;
    }

    p,
    li {
      line-height: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.65);
      margin: 0 0 4px;

      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }

    .text1 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #000;
    }

    .text2 {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #000;
    }

    .closeBtn {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
  }
}
</style>
